export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResearchYear.vue?vue&type=template&id=23e96f8d"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchYear.vue?vue&type=template&id=23e96f8d
// module id = 413
// module chunks = 0